import React, { useState } from 'react';
import styled from 'styled-components';
import { Icon } from 'bench-internal-theme';

type CardProps = {
  header: string;
  headerIcon?: React.ReactElement;
  defaultExpanded?: boolean;
  children?: React.ReactElement | React.ReactElement[];
};

const Container = styled.div`
  width: 350px;
  border: 2px solid #e4e5e7;
  margin-bottom: 20px;
`;

const Header = styled.div`
  height: 70px;
  display: flex;
  align-items: center;
  border-bottom: 2px solid #e4e5e7;
  &:hover {
    background-color: #f9fafc;
    cursor: pointer;
  }
  user-select: none;
`;

const HeaderIcon = styled.div`
  display: flex;
  align-items: center;
  padding-top: 4px;
  margin-left: 20px;
  padding-right: 8px;
`;

const HeaderText = styled.div`
  font-weight: bold;
  padding-top: 4px;
`;

const Caret = styled(Icon)`
  margin-left: auto;
  margin-right: 20px;
  cursor: pointer;
`;

const DetailsContainer = styled.div`
  padding: 0;
  overflow-y: auto;
  max-height: 1000px;
`;

const Card = ({ header, headerIcon, defaultExpanded, children }: CardProps) => {
  const [expanded, setExpanded] = useState(defaultExpanded);
  return (
    <Container>
      <Header onClick={() => setExpanded(!expanded)}>
        <HeaderIcon>{headerIcon}</HeaderIcon>
        <HeaderText>{header}</HeaderText>
        {expanded ? <Caret icon={'caretUp'} /> : <Caret icon={'caretDown'} />}
      </Header>
      {expanded ? <DetailsContainer>{children}</DetailsContainer> : <div></div>}
    </Container>
  );
};

export default Card;
